import { alpha, Box, Stack, Typography, useTheme } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function SimilaritySummaryValue({ label, value, dataCy, icon, palette = "primary" }) {
    const theme = useTheme()
    const color = theme.palette[palette]?.main ?? theme.palette.primary.main

    return (
        <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            data-cy={dataCy}
            sx={{
                minWidth: 0,
                minHeight: 72,
                height: "100%",
                p: 1.5,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1.5,
                bgcolor: "action.hover",
            }}
        >
            <Box
                sx={{
                    display: "grid",
                    placeItems: "center",
                    width: 40,
                    height: 40,
                    flexShrink: 0,
                    borderRadius: "50%",
                    color,
                    bgcolor: alpha(color, 0.12),
                }}
            >
                <Iconify icon={icon} width={22} />
            </Box>
            <Box minWidth={0}>
                <Typography variant="h5" lineHeight={1}>
                    {value}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                    {label}
                </Typography>
            </Box>
        </Stack>
    )
}
